import type { DispatchMethod } from "./types";

/** Dispatch method values — matches backend DISPATCH_METHODS, order preserved (used by the form select) */
export const DISPATCH_METHODS: DispatchMethod[] = [
  "pickup",
  "delivery",
  "courier",
];

/** Spanish UI labels for each dispatch method key */
export const methodLabels: Record<DispatchMethod, string> = {
  pickup: "Cliente recoge",
  delivery: "Ruta interna",
  courier: "Transportadora",
};
